export function shouldPreserveLibraryScroll(previousPathname, nextPathname) {
  const isLibraryPath = (pathname) => /^\/library(?:\/[^/]+)?\/?$/.test(pathname || '');
  return isLibraryPath(previousPathname) && isLibraryPath(nextPathname);
}
